import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4a2d8d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "process-edit-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"var(--el-color-danger)","margin-left":"2px"} }, "*", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      "max-height": "300",
      width: "100%",
      data: _ctx.compData,
      ref: "tableNode",
      "empty-text": _ctx.$t('common.noData')
    }, {
      default: _withCtx(() => [
        (_ctx.cols.includes('name'))
          ? (_openBlock(), _createBlock(_component_el_table_column, { key: 0 }, {
              header: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('processEdit.colProcessName')), 1),
                _hoisted_2
              ]),
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  modelValue: scope.row.name,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.name) = $event),
                  modelModifiers: { trim: true },
                  size: "small",
                  placeholder: _ctx.$t('common.phProcessExe')
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.cols.includes('path'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: _ctx.$t('processEdit.colProcessPath')
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  modelValue: scope.row.path,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.path) = $event),
                  modelModifiers: { trim: true },
                  size: "small",
                  placeholder: _ctx.$t('processEdit.phProcessPath')
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.cols.includes('md5'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: _ctx.$t('processEdit.colProcessMd5')
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  modelValue: scope.row.md5,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.md5) = $event),
                  modelModifiers: { trim: true },
                  maxlength: 32,
                  size: "small",
                  placeholder: _ctx.$t('processEdit.phProcessMd5')
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (_ctx.cols.includes('signature'))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              label: _ctx.$t('processEdit.colSignature')
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_input, {
                  modelValue: scope.row.signature,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.signature) = $event),
                  modelModifiers: { trim: true },
                  size: "small",
                  placeholder: _ctx.$t('processEdit.phSignature')
                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('listColumns.operation'),
          width: "80"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "text",
              class: "cm-link-danger",
              size: "small",
              onClick: ($event: any) => (_ctx.delProcess(scope.$index))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data", "empty-text"]),
    _createVNode(_component_el_button, {
      style: {"margin":"10px"},
      type: "primary",
      plain: "",
      size: "small",
      icon: "el-icon-plus",
      onClick: _ctx.addProcess
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('processEdit.addProcess')), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}